// No ua-parser-js / bowser / detect-browser dependency on purpose. We only
// need three buckets (Safari, Firefox, iOS Chrome) and the library databases
// don't change our output for the cases that matter — in-app webviews and
// iPad desktop-mode are correctly flagged as WebKit by a simple `Safari/`
// match. If we ever want broader facts (old-Chrome warnings, in-app detection
// for OAuth, device class routing), swap to `bowser` and consolidate.

export type UnsupportedBrowser = "safari" | "firefox" | "ios-chrome";

// Returns the user's browser if it's one we don't officially support
// (iframed Google Docs break under stricter default privacy/security
// settings in WebKit and Firefox), otherwise null. Exposed as a pure
// function of the UA string so it's unit-testable without mocking
// `navigator`.
//
// Detection order matters: desktop Safari, Chrome, Edge, Brave, Opera, and
// Arc all include the substring `Safari/` in their UA, so the Safari
// branch must come last and explicitly exclude every Chromium-based UA
// token we know about. `CriOS` (iOS Chrome) and `FxiOS` (iOS Firefox) are
// actually Safari WebKit under the hood and hit the same issue.
export function detectUnsupportedBrowser(
  ua: string = typeof navigator !== "undefined" ? navigator.userAgent : "",
): UnsupportedBrowser | null {
  if (!ua) return null;

  if (ua.includes("CriOS/")) return "ios-chrome";
  if (ua.includes("FxiOS/")) return "firefox";
  if (ua.includes("Firefox/")) return "firefox";

  const isChromium =
    ua.includes("Chrome/") ||
    ua.includes("Chromium/") ||
    ua.includes("Edg/") ||
    ua.includes("EdgiOS/") ||
    ua.includes("OPR/") ||
    ua.includes("SamsungBrowser/");

  if (ua.includes("Safari/") && !isChromium) return "safari";

  return null;
}
